import { IPlayer } from '../../../store/user/store';

export const isPlayer = (item: any): item is IPlayer => (item as IPlayer).profile !== undefined;
